<template>
  <div>
    <van-nav-bar fixed title="新建调拨单" left-arrow @click-left="onClickLeft" />

    <div id="aaa"></div>

    <van-cell-group title="调出中心" :border="false" style="margin-left: 10px;">
      <van-cell
        icon="location-o"
        :title="currentAgent.name"
        is-link
        to="pwalist"
        style="border-bottom:0.1px solid 	#F5F5F5"
      />
    </van-cell-group>

    <van-cell-group title="调入中心" :border="false" style="margin-left: 10px;">
      <van-cell
        icon="location-o"
        :title="receiverName"
        is-link
        @click="toReceiverList"
        style="border-bottom:0.1px solid 	#F5F5F5"
      />
    </van-cell-group>

    <van-cell-group title="备注" :border="false">
      <van-cell icon="edit" style="border-bottom:0.1px solid 	#F5F5F5">
        <van-field
          v-model="message"
          rows="2"
          autosize
          type="textarea"
          maxlength="50"
          placeholder="科室领用"
          show-word-limit
        />
      </van-cell>
    </van-cell-group>

    <van-cell-group title="调拨明细" :border="false">
      <van-cell class="box">
        <van-swipe-cell
          v-for="(item,index) in allotDetail"
          :key="index"
        >
          <van-cell-group :border="false">
            <van-cell class="detailcell">
              <van-row class="ha" type="flex" justify="space-between">
                <van-col span="22">
                  <span style="#323233!important">型号</span>
                  {{item.modelname}}
                </van-col>
                
              </van-row>
              <van-row type="flex">
                <van-col span="24">
                  <span style="color:#969799">库存数量:</span>
                  {{item.quantity + item.unit}}
                </van-col>
              </van-row>
              <van-row type="flex" justify="space-between">
                <van-col span="20">
                  <span style="color:#969799">调出数量:</span>
                  <input
                    type="text"
                    style="width:70%;border:none"
                    v-model="item.count"
                  />
                </van-col>
                <!--<van-col span="4"><van-image round width="0.8rem" height="0.8rem" src="/img/del.png" @click="del(index)"/></van-col>-->
              </van-row>
              <van-row type="flex">
                <van-col span="24">
                  <span style="color:#969799">调入仓库:</span>
                  <van-tag
                    plain
                    type="danger"
                    size="large"
                    color="#838683"
                    text-color="#838683"
                    v-for="(warehousenam,warehouseind) in receiverWarehouse"
                    :key="warehouseind"
                    round
                    :class="{selected:warehousenam.id==item.warehouseselected}"
                    @click="toggleDetSel(warehousenam.id,index)"
                  >{{warehousenam.warehouse_name}}</van-tag>
                  
                </van-col>
              </van-row>
              
            </van-cell>
          </van-cell-group>
          <van-button
            style="height: 100%;"
            slot="right"
            square
            text="删除"
            type="danger"
            class="delete-button"
            @click="del(index)"
          />
        </van-swipe-cell>
      </van-cell>
      <van-cell>
        <van-icon name="add-o" color="#07c160" size="40" @click="add" style="float:right" />
      </van-cell>
    </van-cell-group>

    
    <van-cell-group>
      <van-cell>
        <van-row type="flex">
          <van-col span="10">
            <van-button
              round
              type="info"
              @click="bc"
            >保存</van-button>
          </van-col>
          <van-col span="2"></van-col>
          <van-col span="10">
            <van-button
              round
              type="info"
              @click="qr"
            >提交</van-button>
          </van-col>
          
        </van-row>
      </van-cell>
    </van-cell-group>

    
    
    <div
      v-show="bottom_tip"
      style="font-size:10px;text-align:center;padding:10px 10px"
    >©2020 一脉阳光集团信息中心</div>
    <van-dialog v-model="show" title="请仔细核查" show-cancel-button @confirm="qrtj">
      <van-cell-group title="影像中心" :border="false" >
        <van-cell :title="currentAgent.name"/>
      </van-cell-group>
      <van-cell-group title="调拨明细" :border="false" >
        <van-cell
          v-for="(item,index) in allotDetail"
          :key="index"
        >
          <van-row type="flex">
            <van-col span="6">耗材型号：</van-col>
            <van-col span="18">{{item.modelname}}</van-col>
          </van-row>
          <van-row type="flex">
            <van-col span="6">调出数量：</van-col>
            <van-col span="18">{{item.count}}</van-col>
          </van-row>
        </van-cell>
      </van-cell-group>
    </van-dialog>
  </div>
</template>

<script>
import {
  SwipeCell,
  NavBar,
  Tag,
  DropdownMenu,
  DropdownItem,
  Col,
  Row,
  Panel,
  Divider,
  Button,
  Dialog,
  Icon,
  Image,
  Toast,
} from "vant";
import { mapState, mapMutations } from "vuex";
export default {
  components: {
    [NavBar.name]: NavBar,
    [Tag.name]: Tag,
    [Toast.name]: Toast,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Image.name]: Image,
    [Button.name]: Button,
    [Dialog.Component.name]: Dialog.Component,
    [Panel.name]: Panel,
    [Divider.name]: Divider,
    [Row.name]: Row,
    [SwipeCell.name]: SwipeCell,
    
  },
  data() {
    return {
      show:false,
      message: "",
      bottom_tip: true,
      //当前选中的影像中心
      currentAgent: "",
      receiverInfo:'',
      receiverName:'',
      receiverErp:'',
      receiverWarehouse:[],
      allotDetail:[],
      flag:'',
    };
  },
  methods: {
    ...mapMutations([
      "changePermissionAgent",
      "changeDefaultAgentIndex",
    ]),
    toggleDetSel(index, ind) {
      this.allotDetail[ind].warehouseselected = index;
      this.$forceUpdate();
    },
    onClickLeft() {
      this.$router.push("/allot");
    },
    toReceiverList() {
      this.$router.push({
        name:'choiceproject',
        params:{
          projectErpCode:this.currentAgent.erp_code,
          checkErp:this.receiverErp,
          from:'addallot',
        }
      });
    },
    
    parseSubmitData(obj) {
      let newarr = [];
      let message = "";
      for (let i = 0; i < obj.length; i++) {
        if (obj[i].count.match(/\D/g)) {
          let num = i + 1;
          message =
            message + "第" + num + "条明细,调出库数量包括非法字符或空格\n";
        }
        if (!obj[i].count || obj[i].count == 0) {
          let num = i + 1;
          message = message + "第" + num + "条明细,调出数量为空或0\n";
        }
        if (
          obj[i].count &&
          obj[i].count > obj[i].quantity &&
          obj[i].count != 0 &&
          !obj[i].count.match(/\D/g)
        ) {
          let num = i + 1;
          message =
            message + "第" + num + "条明细,调出数量不能超过库存数量！\n";
        }
        if (!obj[i].warehouseselected) {
          let num = i + 1;
          message = message + "第" + num + "条明细,未选择调入仓库！\n";
        }
        let newobj = {
          stock_id: obj[i].id,
          warehouse_id: obj[i].warehouseselected,
          brand_uuid: obj[i].brand_uuid,
          model_uuid: obj[i].model_uuid,
          unit: obj[i].unit,
          unitcost: obj[i].unit_cost,
          quantity: obj[i].count,
        };
        newarr.push(newobj);
      }
      return {
        message: message,
        data: newarr,
      };
    },
    bc() {
      this.show = true;
      this.flag = "1";
    },
    qr() {
      this.show = true;
      this.flag = "2";
    },
    qrtj() {
      let that = this;
      if (!this.allotDetail[0]) {
        Toast("明细不能为空");
        return;
      }
      let result = this.parseSubmitData(this.allotDetail);
      // window.console.log(result);
      if (result.message) {
        Toast(result.message);
        return;
      } else {
        let data = {
          transfer_out_project: this.currentAgent.erp_code,
          transfer_in_project: this.receiverErp,
          creater: localStorage.getItem("usermobile"),
          remark: this.message?this.message:"调拨申请",
          currentnode:this.flag,
          detail: result.data,
        };
        //window.console.log(data);
        Toast.loading({
          message: "加载中...",
          forbidClick: true,
        });
        //window.console.log(data);
        this.$http({
          method: "post",
          url: "/mobile/transfer/createTransferOrder",
          data,
        }).then(function (response) {
          if (response.state == 200) {
            Toast.success("创建成功");
            //window.console.log(response);
            that.$router.push("allot");
          }
        });
      }
    },
    del(index) {
      this.allotDetail.splice(index,1);
    },
    add() {
      let extra = {
        message:this.message,
        receiverInfo:this.receiverInfo,
      }
      this.$router.push({
        name: "stockdetail",
        params: {
          from: "addallot",
          projectErpCode:this.currentAgent.erp_code,
          warehouse:this.currentAgent.warehouse,
          container:this.allotDetail,
          extra,
        },
      });
    },
  },
  computed: {
    ...mapState(["permissionAgent", "defaultAgentIndex"]),
  },
  created() {
    if (this.permissionAgent) {
      let _this = this;
      this.currentAgent = this.permissionAgent.find(function (item) {
        return item.id == _this.defaultAgentIndex;
      });
      this.message = this.$route.params.extra && this.$route.params.extra.message ? this.$route.params.extra.message : '';
      this.allotDetail = this.$route.params.container ? this.$route.params.container : [];
      this.receiverInfo = this.$route.params.extra && this.$route.params.extra.receiverInfo ? this.$route.params.extra.receiverInfo : '';
      this.receiverName = this.receiverInfo ? this.receiverInfo.name : '';
      this.receiverErp = this.receiverInfo ? this.receiverInfo.erp_code : '';
      this.receiverWarehouse = this.receiverInfo ? this.receiverInfo.warehouse : [];
    } else {
      let _this = this;
      this.$http
        .post("/mobile/rimsAgentList", {
          username: localStorage.getItem("usermobile"),
        })
        .then(function (response) {
          _this.changePermissionAgent(response.rimsAgent);
          _this.changeDefaultAgentIndex(response.rimsAgent[0].id);
          _this.currentAgent = _this.permissionAgent.find(function (item) {
            return item.id == _this.defaultAgentIndex;
          });
        });
    }
  },
};
</script>
<style scoped lang="less">
.selected {
  background-color: #e2f3e2 !important;
  color: #32ca72 !important;
}
.van-nav-bar {
  background: #ffffff;
  color: #323233;
  font-weight: bold;
  /*background: #456;*/
  /*color:white;*/
}
.van-nav-bar__title {
  font-weight: 800;
  color: #323233;
}
.van-nav-bar .van-icon {
  color: black;
}
.ha {
  border-bottom: 0.2px solid #dcdcdc;
}
.box {
  background-color: #fff;
}

.van-button {
  width: 100%;
}
#aaa {
  width: 100vw;
  height: 46px;
}
#add {
  position: fixed;
  top: 300px;
  right: 0;
}
.van-cell-group__title {
  color: #323233 !important;
  font-weight: bold;
  font-size: 0.38rem;
  background-color: #f7f8fa;
}
.van-cell {
  color: #969799 !important;
}
.van-tag--danger.van-tag--plain {
  color: rgb(131, 134, 131);
}
.detailcell {
  line-height: 1rem !important;
  border: 1px solid #dadae4;
  margin-bottom: 10px;
  background: #f7f8fa;
}
</style>